<template>
  <div class="loader-container">
    <slot />
    <div class="app-loader" v-show="isLoading">
      <div class="app-loader-animation">
        <div class="app-loader-animation-inner animation-one"></div>
        <div class="app-loader-animation-inner animation-two"></div>
        <div class="app-loader-animation-inner animation-three"></div>
      </div>
      <span class="app-loading-text">Loading ....</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isLoading(value: boolean) {
      document.documentElement.style.overflow = value ? "hidden" : "";
    },
  },
});
</script>
<style scoped lang="scss">
@import "node_modules/shared-components/assets/colors.scss";
.app-loader {
  z-index: 999;
  height: unset;
  width: unset;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 0;
  margin: 0;
  color: #2b4347;
  background-color: rgba(black, 0.7);
}

.app-loader-animation {
  position: fixed;
  top: 40%;
  left: 50%;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  perspective: 800px;
}

.app-loader-animation > .app-loader-animation-inner {
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.app-loader-animation > .app-loader-animation-inner.animation-one {
  left: 0%;
  top: 0%;
  animation: rotate-one 1s linear infinite;
  border-bottom: 5px solid $racecar;
}

.app-loader-animation > .app-loader-animation-inner.animation-two {
  right: 0%;
  top: 0%;
  animation: rotate-two 1s linear infinite;
  border-right: 5px solid $racecar;
}

.app-loader-animation > .app-loader-animation-inner.animation-three {
  right: 0%;
  bottom: 0%;
  animation: rotate-three 1s linear infinite;
  border-top: 5px solid $racecar;
}

.app-loading-text {
  text-align: center;
  font-size: 14px;
  position: absolute;
  top: calc(50% - 70px);
  left: calc(50% - 100px);
  width: 200px;
  height: 64px;
  margin: 0;
  padding: 0;
  color: white;
  display: none;
}

@keyframes rotate-one {
  0% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);
  }

  100% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);
  }
}

@keyframes rotate-two {
  0% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);
  }

  100% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);
  }
}

@keyframes rotate-three {
  0% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);
  }

  100% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);
  }
}
</style>
